export default "__VITE_ASSET__SVHJ5lbf__"